import $ from "jquery";
import * as Common from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";

export default function standart() {}

export const fillDetail = () => {
  $("#d-algemeen-gisratio").html(
    window.$mm_performance_selectedRow.algemeenGisratio
  );
  $("#d-maatregel-naam").html(window.$mm_performance_selectedRow.maatregelNaam);
  $("#d-planning-globaleplanning").html(window.$mm_performance_selectedRow.planningGlobalePlanning);
  $("#d-planning-detailplanning").html(window.$mm_performance_selectedRow.planningDetailPlanning);
  $("#d-status").html(window.$mm_performance_selectedRow.status);
  $("#d-discipline-naam").html(
    window.$mm_performance_selectedRow.disciplineNaam
  );
  $("#d-werkplan-naam").html(
    window.$mm_performance_selectedRow.werkplanNaam
  );
  $("#d-planningsperiode-startdatum").html(
    window.$mm_performance_selectedRow.planningsPeriodeStartdatum
  );
  
  $("#d-status-tijdstip_verzonden").html(
    window.$mm_performance_selectedRow.statusTijdstipVerzonden
  );
};

export function GetColumnProperties(callType) {}
export function GetColumnPropertiesForModel(
  model,
  pageNr,
  pageSize,
  callType,
  itemId,
  token
) {}


export async function DefinationStatus() {
  var model = {
    definitions: ["b2cd4bcd-0840-4953-85bb-b42ef9fbee78"],
    query: {
      definitions: ["b2cd4bcd-0840-4953-85bb-b42ef9fbee78"],
    },
  };
  let result = await omnimap.GetDefinationStatusAction(
    model,
    window.$mm_management_units_token
  );

  if (result.data !== undefined) {
    result.data.forEach((element) => {
      window.$mm_performance_plannigStatus.push(element.status);
    });
  }
}